import {Component} from '@angular/core';

@Component({
    selector: 'tfl-outgoing-exchange-transfer-icon',
    template: require('./outgoing-exchange.html')
})
export class OutgoingExchangeTransferIcon {
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/icons/outgoing/outgoing.exchange.transfer.icon.ts